import { render, staticRenderFns } from "./insure_main.vue?vue&type=template&id=441aa31c&scoped=true"
import script from "./insure_main.vue?vue&type=script&lang=js"
export * from "./insure_main.vue?vue&type=script&lang=js"
import style0 from "./insure_main.vue?vue&type=style&index=0&id=441aa31c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "441aa31c",
  null
  
)

export default component.exports